import React from 'react';
import { Box, keyframes } from '@mui/material';

// Define pulse animation
const pulse = keyframes`
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

// Define rotation animation
const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const WyspurLoadingSpinner = () => {
  console.log('WyspurLoadingSpinner: Component rendering');
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          position: 'relative',
          animation: `${pulse} 2s ease-in-out infinite`,
        }}
      >
        <img
          src="/logo-full-cropped.png"
          alt="Loading..."
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
        {/* Optional rotating border effect */}
        <Box
          sx={{
            position: 'absolute',
            top: -10,
            left: -10,
            right: -10,
            bottom: -10,
            border: '2px solid transparent',
            borderTopColor: '#0095FF',
            borderRadius: '50%',
            animation: `${rotate} 1.5s linear infinite`,
          }}
        />
      </Box>
    </Box>
  );
};

export default WyspurLoadingSpinner;